import { getCustomerPortalInteriorPagesPaths } from "@du/routes/cw-routes";

//prettier-ignore
const BRAND_CSS_BUNDLE_MAP = new Map<string, Function>([
  ["cw.css",            () => import("../../css/legacy/custPortal/app/_app-config.export")],
  ["capcity.css",       () => import("../../css/legacy/custPortal/app/capcity/_app-config.export")],
  ["sauder.css",        () => import("../../css/legacy/custPortal/app/sauder/_app-config.export")],
  ["affordable.css",    () => import("../../css/legacy/custPortal/app/affordable/_app-config.export")],
  ["stowe.css",         () => import("../../css/legacy/custPortal/app/stowe/_app-config.export")],
]);

//#region js imports

export const importS1WebLegacyJsBundles = (libFunction: string): Promise<any> => {
  return import("jquery").then((x) => {
    if (libFunction === "hana.pages.tickerDisplay.init") {
      const epcImports = [
        import("../legacy/s1Web/hana/lib/hana.prototype.js"),
        import("../legacy/s1Web/hana/hana.js"),
        import("../legacy/s1Web/hana/lib/hana.constants.js"),
        import("../legacy/s1Web/hana/lib/hana.appEnum.js"),
        import("../legacy/s1Web/hana/lib/hana.utility.js"),
        import("../legacy/s1Web/hana/lib/hana.webservices.js"),
        import("../legacy/s1Web/hana/lib/hana.templating.js"),
        import("../legacy/s1Web/hana/lib/hana.uiCommon.js"),
        import("../legacy/s1Web/hana/lib/hana.loadingIndicator.js"),
        import("../legacy/s1Web/hana/lib/hana.map.js"),
        import("../legacy/s1Web/hana/hana.pages.epcDisplay.js"),
        import("../legacy/s1Web/hana/hana.pages.epcGraphSet.js"),
        import("../legacy/s1Web/hana/hana.pages.tickerDisplay.js"),
      ];
      return Promise.all(epcImports);
    }

    const s1WebImports = [
      import("../legacy/s1Web/lib/morris/morris.js"),
      import("../legacy/s1Web/lib/video/responsible-video.js"),

      import("../legacy/s1Web/hana/lib/hana.prototype.js"),
      import("../legacy/s1Web/hana/hana.js"),
      //#region Hana Util/Lib
      import("../legacy/s1Web/hana/lib/hana.spin.js"),
      import("../legacy/s1Web/hana/lib/hana.constants.js"),
      import("../legacy/s1Web/hana/lib/hana.appEnum.js"),
      import("../legacy/s1Web/hana/lib/hana.utility.js"),
      import("../legacy/s1Web/hana/lib/hana.webservices.js"),
      import("../legacy/s1Web/hana/lib/hana.templating.js"),
      import("../legacy/s1Web/hana/lib/hana.alert.js"),
      import("../legacy/s1Web/hana/lib/hana.uiCommon.js"),
      import("../legacy/s1Web/hana/lib/hana.modal.js"),
      import("../legacy/s1Web/hana/lib/hana.loadingIndicator.js"),
      import("../legacy/s1Web/hana/lib/hana.map.js"),
      import("../legacy/s1Web/hana/lib/hana.S1CustomerCommon.js"),
      import("../legacy/s1Web/hana/lib/hana.dtTools.js"),
      //#endregion Hana Util/lib

      //#region formbuilder
      import("../legacy/s1Web/lib/formBuilder/form-builder.js"),
      import("../legacy/s1Web/lib/formBuilder/form-render.js"),
      import("../legacy/s1Web/hana/hana.pages.formBuilderEditor.js"),
      import("../legacy/s1Web/hana/lib/hana.formBuilder.js"),
      import("../legacy/s1Web/hana/lib/hana.eDocumentSigning.js"),
      //#endregion formbuilder

      //#region Pages
      import("../legacy/s1Web/hana/hana.siteMaster.js"),
      import("../legacy/s1Web/hana/hana.pages.dashboard.js"),
      import("../legacy/s1Web/hana/hana.pages.templateListing.js"),
      import("../legacy/s1Web/hana/hana.pages.graphGroupingAdmin.js"),
      //#endregion Pages

      //#region Dashboard
      import("../legacy/s1Web/hana/dashboard/hana.dashboard.js"),
      import("../legacy/s1Web/hana/dashboard/hana.dashboard.genericDataSet.js"),
      import("../legacy/s1Web/hana/dashboard/hana.dashboard.genericGraphGrouping.js"),
      import("../legacy/s1Web/hana/dashboard/STE/hana.dashboard.steActiveCustomers.js"),
      import("../legacy/s1Web/hana/dashboard/hana.dashboard.zipPriceWidget.js"),
      import("../legacy/s1Web/hana/dashboard/hana.dashboard.customerApplication.js"),
      import("../legacy/s1Web/hana/dashboard/hana.dashboard.tickerWidget.js"),
      //#endregion Dashboard
      //
      //
      //#region DashboardConfig
      import("../legacy/s1Web/hana/dashboard/config/dashboardConfig.js"),
      import("../legacy/s1Web/hana/dashboard/config/genericDashboardWidgetConfig.js"),
      import("../legacy/s1Web/hana/dashboard/config/customerApplicationConfig.js"),
      import("../legacy/s1Web/hana/dashboard/config/zipPriceCheckConfig.js"),
      import("../legacy/s1Web/hana/dashboard/config/tickerWidgetConfig.js"),
      //#endregion DashboardConfig
      //
      //
      //#region Widgets
      import("../legacy/s1Web/hana/hana.widget.assetUpload.js"),
      import("../legacy/s1Web/hana/hana.widget.versionedTemplate.js"),
    ];

    return Promise.all(s1WebImports);
  });
};

export const importFormBuilderJsBundles = () =>
  Promise.all([
    import("../legacy/s1Web/lib/formBuilder/form-builder.js"),
    import("../legacy/s1Web/lib/formBuilder/form-render.js"),
    import("../legacy/s1Web/hana/hana.pages.formBuilderEditor.js"),
    import("../legacy/s1Web/hana/lib/hana.formBuilder.js"),
    import("../legacy/s1Web/hana/lib/hana.eDocumentSigning.js"),
  ]);

/**
 * Loads the minimal legacy runtime needed to render formBuilder forms (and the leak-check form widget)
 * from a frontend-routed Vue page, where none of the legacy bundles are loaded.
 * Stage one loads the hana core libs so `window.hana` exists before the formBuilder modules evaluate.
 */
export const importFormRenderLegacyRuntime = (): Promise<any> =>
  import("jquery")
    .then(() =>
      Promise.all([
        import("../legacy/s1Web/hana/lib/hana.prototype.js"),
        import("../legacy/s1Web/hana/lib/hana.spin.js"),
        import("../legacy/s1Web/hana/lib/hana.constants.js"),
        import("../legacy/s1Web/hana/lib/hana.appEnum.js"),
        import("../legacy/s1Web/hana/lib/hana.utility.js"),
        import("../legacy/s1Web/hana/lib/hana.webservices.js"),
        import("../legacy/s1Web/hana/lib/hana.templating.js"),
        import("../legacy/s1Web/hana/lib/hana.alert.js"),
        import("../legacy/s1Web/hana/lib/hana.uiCommon.js"),
        import("../legacy/s1Web/hana/lib/hana.modal.js"),
        import("../legacy/s1Web/hana/lib/hana.loadingIndicator.js"),
      ])
    )
    .then(() =>
      Promise.all([
        import("../legacy/s1Web/lib/formBuilder/form-builder.js"),
        import("../legacy/s1Web/lib/formBuilder/form-render.js"),
        import("../legacy/s1Web/hana/lib/hana.formBuilder.js"),
        import("../legacy/s1Web/hana/lib/hana.eDocumentSigning.js"),
        import("../legacy/s1Web/hana/hana.widget.leakForm.js"),
      ])
    );

export const importCustomerPortalJsBundles = () => {
  return import("jquery").then((x) => {
    const customerPortalJsImports = [
      import("../legacy/custPortal/cw/cw.js"),
      import("../legacy/custPortal/cw/lib/cw.constants.js"),
      import("../legacy/custPortal/cw/lib/cw.prototype.js"),
      import("../legacy/custPortal/cw/lib/cw.modal.js"),
      import("../legacy/custPortal/cw/lib/cw.webservices.js"),
      import("../legacy/custPortal/cw/lib/cw.templating.js"),
      import("../legacy/custPortal/cw/lib/cw.appEnum.js"),
      import("../legacy/custPortal/cw/lib/cw.utility.js"),
      import("../legacy/custPortal/cw/lib/cw.dtTools.js"),
      import("../legacy/custPortal/cw/lib/cw.alert.js"),
      import("../legacy/custPortal/cw/lib/cw.uiCommon.js"),
      import("../legacy/custPortal/cw/lib/cw.loadingIndicator.js"),
      import("../legacy/custPortal/cw/cw.siteMaster.js"),
    ];
    return Promise.all(customerPortalJsImports);
  });
};

//#endregion js imports

//#region css imports
export const importS1WebLegacyCssBundles = (): Promise<any> =>
  Promise.all([
    import("../../css/legacy/s1web/bs/_bootstrap.export"),
    import("../../css/legacy/s1web/bs-theme-base/_base-config.export"),
    import("../../css/legacy/s1web/app/_jsoneditor.export"),
    import("../../css/_app-config.export"),
    import("../../css/legacy/s1web/app/_app-config.export"),
  ]);

export const importGuidedExperienceCssBundles = (): Promise<unknown> =>
  import("../../css/legacy/custPortal/bootstrap_v3.3.5/_bootstrap.export");

export const importCustomerPortalCssBundles = (): Promise<any> => {
  const pathName = window.location.pathname?.toLowerCase() ?? "";
  const isCustPortalInterior = getCustomerPortalInteriorPagesPaths().some((s) => pathName.startsWith(s));
  const bundles = [import("../../css/legacy/custPortal/bootstrap_v3.3.5/_bootstrap.export")];
  if (isCustPortalInterior) {
    bundles.push(setBrandLegacyCssBundle("cw.css"));
    bundles.push(import("../../css/legacy/custPortal/legacy/_legacy_config.export"));
  }
  return Promise.all(bundles);
};

export const setBrandLegacyCssBundle = (brandBundle: string): Promise<any> => {
  const bundleImport = BRAND_CSS_BUNDLE_MAP.get(brandBundle);
  if (bundleImport && typeof bundleImport === "function") {
    return bundleImport();
  }

  console.warn(`No brand bundle found for ${brandBundle}`);
  return Promise.resolve();
};

//#endregion css imports
